/* hs-eslint ignored failing-rules */

import { useMutation } from 'data-fetching-client';
import { generatePath, useHistory } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useFeaturePermission } from 'automation-ui-permissions/feature-permissions/hooks/featurePermissionHooks';
import { EDIT_ENROLLMENT } from 'automation-ui-permissions/feature-permissions/constants/WorkflowManagementFeatures';
import { setAiGeneratedEnrollment as _setAiGeneratedEnrollment } from 'automation-ui-canvas/actions/AiAssistantActions';
import { updateFlowLocally as _updateFlowLocally } from 'automation-ui-canvas/actions/FlowActions';
import GenerateButton from 'automation-ui-canvas/components/panels/ai-assistant-panel/GenerateButton';
import { AI_ASSISTANT_GENERATE_ASSET } from 'automation-ui-canvas/constants/AbsolutePaths';
import Flow from 'automation-ui-canvas/flow/records/Flow';
import { wireFlowById } from 'automation-ui-canvas/queries/flowQueries';
import { AI_GENERATE_ENROLLMENT, AI_GENERATE_ENROLLMENT_FIELD_NAME } from 'automation-ui-canvas/queries/opsHubAiQueries';
import { useEffect } from 'react';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const GenerateTriggerButton = ({
  flow,
  flowId,
  onError,
  setAiGeneratedEnrollment,
  updateFlowLocally,
  userInput
}) => {
  const history = useHistory();
  const trackEvent = useTrackEvent();
  const {
    hasFeatureAccess: hasEditEnrollmentAccess
  } = useFeaturePermission({
    feature: EDIT_ENROLLMENT
  });
  const [generateEnrollment, {
    error,
    loading
  }] = useMutation(AI_GENERATE_ENROLLMENT, {});
  useEffect(() => {
    onError(!!error);
  }, [error, onError]);
  const handleGenerateTrigger = () => {
    generateEnrollment({
      variables: {
        filterGroupInputs: userInput,
        objectTypeId: flow === null || flow === void 0 ? void 0 : flow.objectTypeId
      }
    }).then(({
      data
    }) => {
      const results = data && data[AI_GENERATE_ENROLLMENT_FIELD_NAME];
      if (results) {
        if (flow) {
          const {
            enrollmentCriteria,
            associatedLists,
            enrollmentTrigger,
            flowEventFilters,
            enrollmentSchedule
          } = results;
          const hasGeneratedTriggers = !!enrollmentCriteria;
          if (hasGeneratedTriggers) {
            const updatedFlow = new Flow(Object.assign({}, flow.toJS(), {
              //@ts-expect-error There is a type mismatch between the GenerateEnrollmentResponse types and the Flow object
              associatedLists,
              enrollmentTrigger,
              enrollmentSchedule,
              // @ts-expect-error There is a type mismatch ListBasedEnrollmentCriteria and GenerateEnrollmentResponse
              enrollmentCriteria: enrollmentCriteria !== null && enrollmentCriteria !== void 0 ? enrollmentCriteria : null,
              // @ts-expect-error EventFilter type mismatch
              flowEventFilters,
              objectTypeId: results.objectTypeId
            }));

            // TODO can we move any of these back down to GenerateButton?
            updateFlowLocally(updatedFlow);
            setAiGeneratedEnrollment(results);
            trackEvent(Trackables.CLICK_TO_GENERATE_ASSET, {
              aiPrompt: userInput ? userInput.map(fg => fg.filterInputs.join(' AND ')).join(' OR ') : '',
              assetType: 'AI Generated Workflow Trigger'
            });
            history.push(generatePath(AI_ASSISTANT_GENERATE_ASSET, {
              assetType: 'triggers',
              flowId
            }));
          } else {
            onError(true);
          }
        }
      }
    }).catch(() => {
      onError(true);
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(GenerateButton, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "aiAssistantPanel.body.addTriggersPanel.triggerDescriptionSection.generateButton"
      }),
      disabled: !hasEditEnrollmentAccess,
      flowId: flowId,
      hasGenerateError: !!error,
      hasValidUserInput: !!userInput.length,
      isGenerateLoading: loading,
      onGenerateClick: handleGenerateTrigger,
      tooltipTitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "aiAssistantPanel.body.addTriggersPanel.triggerDescriptionSection.missingInputTooltip"
      })
    })
  });
};
export default compose(wireFlowById, connect(() => ({}), {
  setAiGeneratedEnrollment: _setAiGeneratedEnrollment,
  updateFlowLocally: _updateFlowLocally
}))(GenerateTriggerButton);